/**
 * @author Fernando Ruano
 * @file storage-helper.js
 * @description General Storage Helper to app
 */

/**
 * Get item from local storage by key
 * @param { string } itemKey - String to use as key
 * @return { Object } - Object with any data storaged
 */
export const getStorageItem = (itemKey) => {
  return localStorage.getItem(itemKey)
    ? JSON.parse(localStorage.getItem(itemKey))
    : null;
};

/**
 * Set item in local storage by key
 * @param { string } itemKey - String to use as key
 * @param { object } item - Object with data to storage
 */
export const setStorageItem = (itemKey, item) => {
  localStorage.setItem(itemKey, JSON.stringify(item));
};

/**
 * Remove item from local storage by key
 * @param { string } itemKey - String to use as key
 */
export const removeStorageItem = (itemKey) => {
  localStorage.removeItem(itemKey);
};

/**
 * Remove all item from local storage
 */
export const removeAllStorageItem = () => {
  localStorage.clear();
};
